import axios from 'axios';


// API 서버 IP 
//const apiUrl = "http://192.168.53.231:8080"; // 개발용 필요시 실행해달라고 해야됨
const apiUrl = ""; // 운영용

export function apiAxios(url, body, callback) {
  axios.post(apiUrl+url, body, {
    headers : {
      "content-type" : "application/json"
    },
  })
  .then((res) => {
    callback(res.data);
  })
  .catch((err) => {
    console.error(err);
    callback(err);
  });
}

export function apiAxiosMulti(url, body, callback) {
  axios.post(apiUrl+url, body, {
    headers : {
      "content-type" : "multipart/form-data"
    },
  })
  .then((res) => {
    callback(res.data);
  })
  .catch((err) => {
    console.error(err);
    callback(err);
  });
}